import { c as _c } from "react/compiler-runtime";
export default function CarePremium() {
  const $ = _c(16);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="summary">안심케어 프리미엄 상품 가입 중개사님께 주어지는 혜택!</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h4 className="title text_blue">안심 계약서 작성</h4>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <strong className="text_blue400">11여가지 공부 데이터<br />연동</strong>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li>{t1}<p className="desc">이실장 계약관리시스템을 활용해{t2}으로 계약서를 작성하실 수 있으며 (멤버십 혜택)<br />서비스 신청 후 전문가가 추가로 꼼꼼히 검토해드려요.</p></li>;
    t4 = <h4 className="title text_primary">등기변동 사건 모니터링</h4>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <strong className="text_primary400">120여가지 등기사건변동<br />모두 모니터</strong>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li>{t4}<p className="desc">계약일부터 잔금일까지{t5}하고 변동사항이 확인되면<br />알림톡으로 전달해드려요.</p></li>;
    t7 = <h4 className="title text_violet">법률 상담 서비스</h4>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <br />;
    t9 = <strong className="text_violet400">​부동산 전문 변호사님과 상담하고 빠르게 해결</strong>;
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <li>{t7}<p className="desc">계약 당사자간 분쟁 등 계약 중 발생하는 돌발이슈도{t8}{t9}해요.<small>* ​단, 소송 진행 시는 별도 협의 필요</small></p></li>;
    t11 = <h4 className="title text_green">권리보험 서비스</h4>;
    $[10] = t10;
    $[11] = t11;
  } else {
    t10 = $[10];
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <br />;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <br />;
    t14 = <strong className="text_green400">권리보험</strong>;
    $[13] = t13;
    $[14] = t14;
  } else {
    t13 = $[13];
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <>{t0}<ul className="list_card">{t3}{t6}{t10}<li>{t11}<p className="desc">매도인이 진짜 집주인이 아닌 경우​ 혹은{t12}고객이 소유권을 취득한 이후에도 소유권을 잃게 되는 경우​{t13}{t14}을 통해 고객의 실손금을 보상해 드려요.<small>* ​보상기준은 보험상품의 보통약관 및 서비스 신청 조건에 따름</small></p></li></ul></>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  return t15;
}